import {createAction, props} from "@ngrx/store";
import {HttpErrorResponse} from "@angular/common/http";
import {TenCustomerService, TenCustomerServiceSearchParams, TenHistory, TenHistoryRequest} from "../../_models/customer-service.models";
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {CategoryHash, OrderCategory} from '@applications/_common/models/order.models';

// <editor-fold desc="Customer Service List">
export const LoadList = createAction(
    '[Customer Service] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Customer Service] Load List Success',
    props<{ payload: { items: TenCustomerService[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Customer Service] Load List Failure',
    props<{ payload: { error: HttpErrorResponse } }>()
);

export const SetPagination = createAction(
    '[Customer Service] Set Pagination',
    props<{ payload: { next: boolean } }>()
);

export const SetFilter = createAction(
    '[Customer Service] Set Filter',
    props<{ payload: { filter: TenCustomerServiceSearchParams } }>()
);

export const SetLoading = createAction(
    '[Customer Service] Set Loading',
    props<{ payload: { loading: DahLoadingType } }>()
);

export const SetItemsLoading = createAction(
    '[Customer Service] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const SetInitialState = createAction(
    '[Customer Service] Set Initial State'
);

export const SetCategoryHashes = createAction(
    '[Customer Service] Set Category Hashes',
    props<{ payload: { associationId: string } }>()
);

export const SetCategoryHashesSuccess = createAction(
    '[Customer Service] Set Category Hashes Success',
    props<{ payload: { categoryHashes: CategoryHash[] } }>()
);

export const SetCategoryHashesFailure = createAction(
    '[Customer Service] Set Category Hashes',
    props<{ payload: { error: HttpErrorResponse } }>()
);

export const SetCategories = createAction(
    '[Customer Service] Set Categories',
    props<{ payload: { associationId: string } }>()
);

export const SetCategoriesSuccess = createAction(
    '[Customer Service] Set Categories Success',
    props<{ payload: { categories: OrderCategory[] } }>()
);

export const SetCategoriesFailure = createAction(
    '[Customer Service] Set Categories Failure',
    props<{ payload: { error: HttpErrorResponse } }>()
);

export const AddItem = createAction(
    '[Customer Service] Add Item',
    props<{ payload: { item: TenCustomerService } }>()
);

export const AddItemSuccess = createAction(
    '[Customer Service] Add Item Success',
    props<{ payload: { item: TenCustomerService } }>()
);

export const AddItemFailure = createAction(
    '[Customer Service] Add Item Failure',
    props<{ payload: { item: TenCustomerService, error: HttpErrorResponse } }>()
);

export const EditItem = createAction(
    '[Customer Service] Edit Item',
    props<{ payload: { item: TenCustomerService } }>()
);

export const EditItemSuccess = createAction(
    '[Customer Service] Edit Item Success',
    props<{ payload: { item: TenCustomerService } }>()
);

export const EditItemFailure = createAction(
    '[Customer Service] Edit Item Failure',
    props<{ payload: { item: TenCustomerService, error: HttpErrorResponse } }>()
);

export const DeleteItem = createAction(
    '[Customer Service] Delete Item',
    props<{ payload: { item: TenCustomerService } }>()
);

export const DeleteItemSuccess = createAction(
    '[Customer Service] Delete Item Success',
    props<{ payload: { item: TenCustomerService } }>()
);

export const DeleteItemFailure = createAction(
    '[Customer Service] Delete Item Failure',
    props<{ payload: { item: TenCustomerService, error: HttpErrorResponse } }>()
);

export const SubscribeOnItem = createAction(
    '[Customer Service] Subscribe On Item',
    props<{ payload: { item: TenCustomerService } }>()
);

export const SubscribeOnItemSuccess = createAction(
    '[Customer Service] Subscribe On Item Success',
    props<{ payload: { item: TenCustomerService, subscribed: boolean, subscribersCount: number } }>()
);

export const SubscribeOnItemFailure = createAction(
    '[Customer Service] Subscribe On Item Failure',
    props<{ payload: { item: TenCustomerService, error: HttpErrorResponse } }>()
);
// </editor-fold desc="Customer Service List">

// <editor-fold desc="Customer Service Item">
export const SetOpenedItem = createAction(
    '[Customer Service] Set Opened Item',
    props<{ payload: { item: TenCustomerService } }>()
);

export const UpdateOpenedItem = createAction(
    '[Customer Service] Update Opened Item',
    props<{ payload: { item: TenCustomerService } }>()
);
// </editor-fold>

// <editor-fold desc="Customer Service Comments">
export const LoadComments = createAction(
    '[Customer Service] Load Comments',
    props<{ payload: { itemId: string, next?: boolean } }>()
);

export const LoadCommentsSuccess = createAction(
    '[Customer Service] Load Comments Success',
    props<{ payload: { comments: TenHistory[], pagination: DahPaginationModel, next?: boolean } }>()
);

export const LoadCommentsFailure = createAction(
    '[Customer Service] Load Comments Failure',
    props<{ error: HttpErrorResponse }>()
);

export const SendComment = createAction(
    '[Customer Service] Send Comment',
    props<{ payload: { item: TenHistoryRequest } }>()
);

export const SendCommentSuccess = createAction(
    '[Customer Service] Send Comment Success',
    props<{ payload: { item: TenHistory } }>()
);

export const SendCommentFailure = createAction(
    '[Customer Service] Send Comment Failure',
    props<{ error: HttpErrorResponse }>()
);

export const EditComment = createAction(
    '[Customer Service] Edit Comment',
    props<{ payload: { itemId: string, comment: string } }>()
);

export const EditCommentSuccess = createAction(
    '[Customer Service] Edit Comment Success',
    props<{ payload: { item: TenHistory } }>()
);

export const EditCommentFailure = createAction(
    '[Customer Service] Edit Comment Failure',
    props<{ error: HttpErrorResponse }>()
);

export const DeleteComment = createAction(
    '[Customer Service] Delete Comment',
    props<{ payload: { itemId: string } }>()
);

export const DeleteCommentSuccess = createAction(
    '[Customer Service] Delete Comment Success',
    props<{ payload: { itemId: string } }>()
);

export const DeleteCommentFailure = createAction(
    '[Customer Service] Delete Comment Failure',
    props<{ error: HttpErrorResponse }>()
);

// </editor-fold>
